import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2421ef49"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "audio-player-container"
}
const _hoisted_2 = { style: {"width":"90%","margin-left":"auto","margin-right":"auto","padding-bottom":"5px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_audio_player = _resolveComponent("audio-player")!

  return (_ctx.audioList.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_audio_player, {
            ref: "audioPlayer",
            "audio-list": _ctx.audioFiles,
            "theme-color": "var(--ion-color-light)",
            "before-play": _ctx.controlAudio,
            showPlaybackRate: false,
            showVolumeButton: false
          }, null, 8, ["audio-list", "before-play"])
        ])
      ]))
    : _createCommentVNode("", true)
}